import { UserStore, trackTimings, alt } from '@reverbdotcom/discovery-ui';
import { configureMParticle } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';
import { frontendCurrentUser, parseMeta } from './parse_meta';
import { datadogRum } from '@datadog/browser-rum';

import * as I18n from 'i18n-js';
import * as moment from 'moment';

import 'moment/locale/de';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';
import 'moment/locale/en-gb';
import 'moment/locale/en-ie';
import 'moment/locale/en-il';
import 'moment/locale/en-nz';
import 'moment/locale/es';
import 'moment/locale/es-us';
import 'moment/locale/fr';
import 'moment/locale/fr-ca';
import 'moment/locale/ja';
import { isExperimentEnabled, experimentInt } from '@reverbdotcom/commons/dist/user_context_helpers';

const AppInitializer = {
  init() {
    this.initializeAltStores();
    this.initializeLocale();
    this.fixFacebookHash();
    this.configureMparticle();
    this.configureRum();
    trackTimings();
  },

  fixFacebookHash() {
    // Facebook adds a strange hash to our url when we log in, which
    // can break tab navigation. This removes it.
    if (window.location.hash === '#_=_') window.location.hash = '';
  },

  initializeLocale() {
    const userConfig = frontendCurrentUser();
    const translation = parseMeta('js-translations');

    if (userConfig) {
      if (UserStore.isExperimentEnabled('five_digit_locales')) {
        I18n.locale = UserStore.fiveDigitLocale() || I18n.defaultLocale;
      } else {
        I18n.locale = userConfig.user.locale || I18n.defaultLocale;
      }

      moment.locale(I18n.locale);

      if (translation) {
        I18n.translations[I18n.locale.slice(0, 2)] = translation;
      }
    }
  },

  initializeAltStores() {
    const stores = document.getElementById('alt-bootstrap');
    // This value is duplicated in two places, so let's share it
    const currentUser = frontendCurrentUser();

    if (stores && currentUser) {
      const parsedStores = JSON.parse(stores.textContent);

      alt.bootstrap(JSON.stringify({
        ...parsedStores,
        UserStore: currentUser.user,
      }));
    }
  },

  configureMparticle() {
    if (process.env.IS_SELENIUM === 'true') return;

    const userConfig = frontendCurrentUser();
    const appConfig = parseMeta('app-config-meta');

    if (userConfig && appConfig) {
      configureMParticle(userConfig.user, appConfig.config.inverseReverseExchangeRates);
    }
  },

  experimentTag(user, experimentKey) {
    return `${experimentKey}:${experimentInt(user, experimentKey)}`;
  },

  configureRum() {
    const userConfig = frontendCurrentUser();
    const user = userConfig && userConfig.user;
    const enableRum = DD_RUM_ENV &&
      user &&
      !user.isBot &&
      isExperimentEnabled(user, 'datadog_rum');

    if (!enableRum) { return; }

    // RQL_HOST is actually a url with a /graphql suffix
    const rqlOrigin = new URL(RQL_HOST).origin;

    datadogRum.init({
      applicationId: 'f985bfcb-6302-45da-b082-152b5d85d60f',
      clientToken: 'pub3937220e6abf34f0ce851dc03e31b7e1',
      site: 'datadoghq.com',
      service: 'core-web-ui',
      sampleRate: 100, // 0-100
      env: DD_RUM_ENV,
      version: DISCO_RELEASE,
      trackInteractions: false,
      allowedTracingOrigins: [
        CORE_API_HOST,
        rqlOrigin,
        WEB_HOST,
      ],
    });

    datadogRum.setUser({
      id: user.id,
      admin: user.isAdmin,
      experiments: [
        this.experimentTag(user, 'item_lazy_toggled_content'),
        this.experimentTag(user, 'marketplace_suggested_bump'),
        this.experimentTag(user, 'logged_out_popular_products'),
        this.experimentTag(user, 'marketplace_filter_row'),
        this.experimentTag(user, 'ssr_homepage_feed_row'),
        this.experimentTag(user, 'marketplace_banner_ad'),
        this.experimentTag(user, 'site_header_v2'),
      ],
    });
  },
};

export default AppInitializer;



// WEBPACK FOOTER //
// ./javascripts/components/app_initializer.js